// Heatmap-only app role (no ADMIN). Backend: set user.roles and allow Outernet heatmap APIs (submissions, hotspots, insights, etc.).
export const ROLE_OUTERNET_HEATMAP_VIEWER = "OUTERNET_HEATMAP_VIEWER";

export function hasAdminDashboardAccess(user) {
  const roles = user && Array.isArray(user.roles) ? user.roles : [];
  return roles.includes("ADMIN");
}

export function isOuternetHeatmapViewerAccount(user) {
  const roles = user && Array.isArray(user.roles) ? user.roles : [];
  return (
    roles.includes(ROLE_OUTERNET_HEATMAP_VIEWER) &&
    !roles.includes("ADMIN")
  );
}
